import type { CheckoutPaymentChoice } from "./CheckoutPaymentMethodBox";

type SavedMethod = { accountId?: string | null } | null | undefined;

/**
 * Default checkout payment from the buyer's most recent order paymentType.
 * Falls back when that method is no longer available (ACH preferred if no history).
 */
export function resolvePreferredPaymentChoice(args: {
  lastPaymentType?: string | null;
  achAccount: SavedMethod;
  cardAccount: SavedMethod;
  cardPaymentEnabled: boolean;
}): CheckoutPaymentChoice {
  const hasAch = Boolean(args.achAccount?.accountId);
  const hasSavedCard = Boolean(args.cardAccount?.accountId);
  const cardsOk = args.cardPaymentEnabled === true;
  const lastWasCard = String(args.lastPaymentType || "").toUpperCase() === "CARD";

  if (lastWasCard) {
    if (cardsOk && hasSavedCard) {
      return "saved_card";
    }
    if (cardsOk) {
      return "one_off";
    }
    if (hasAch) {
      return "ach";
    }
    return "one_off";
  }

  // Last order was ACH, or buyer has no prior orders.
  if (hasAch) {
    return "ach";
  }
  if (cardsOk && hasSavedCard) {
    return "saved_card";
  }
  if (cardsOk) {
    return "one_off";
  }
  return "ach";
}
